import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { COURIER_SERVICE_TYPE } from 'domains/customer-refund-shipment/constants'


const propTypes = {
  courier_service_type: PropTypes.string
}

/**
 * Badge for Customer Refund Shipment courier service type.
 * @param {string} courier_service_type selected courier service type
 */
const CustomerRefundServiceCourierServiceTypeBadge = ({ courier_service_type }) => {

  const colorMap = {
    [COURIER_SERVICE_TYPE.REG] : 'primary',
    [COURIER_SERVICE_TYPE.ECO] : 'warning'
  }

  const color = colorMap[courier_service_type] || 'default'

  return <StatusBadge color={ color } label={ courier_service_type } />
}

CustomerRefundServiceCourierServiceTypeBadge.propTypes = propTypes

export default CustomerRefundServiceCourierServiceTypeBadge
